import { Button as AntdButton, type ButtonProps as AntdButtonProps } from "antd"
import type { ReactElement, ReactNode } from "react"
import { Trans, useTranslation } from "react-i18next"

import "./Button.less"

export interface ButtonProps extends AntdButtonProps {
  strKey?: string
  i18n?: {
    values?: Record<string, unknown>
    components?: ReactElement[]
  }
  suffixIcon?: ReactNode
}

/**
 * Base component for our button
 */
export function Button(props: ButtonProps): ReactElement | null {
  const { strKey, children, i18n, icon, className = "", suffixIcon, ...rest } = props
  // Trans component does not use suspense well for ns,
  // so using the hook as well
  const { t, i18n: i18nLib } = useTranslation()
  return (
    <AntdButton className={`OneschemaButton ${className}`} {...rest}>
      {icon && <div className="OneschemaButton__icon">{icon}</div>}
      {strKey ? (
        <span dir={i18nLib.dir()}>
          <Trans t={t} i18nKey={strKey} {...i18n}>
            {children}
          </Trans>
        </span>
      ) : (
        children
      )}
      {suffixIcon && (
        <div className="OneschemaButton__suffix-icon ant-select-arrow">{suffixIcon}</div>
      )}
    </AntdButton>
  )
}
